










import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import ExternalLogin from '@/components/organisms/external-login/ExternalLogin.vue'
import LoadingMixin from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'

import { isExternalLoginEnabled, shouldDisplayForTargetBrand } from '@spa/router/externalLogin'

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    ExternalLogin,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class ShortcutLoginArea extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  redirectEndpoint: string

  @Prop({ required: true })
  brandName: string

  get targetBrand(): string[] {
    // カートログインページでは、特定の1ブランド分しか表示しないため

    return [this.brandName]
  }

  get shouldShowExternalLoginButtonArea(): boolean {
    return isExternalLoginEnabled() && shouldDisplayForTargetBrand(this.brandName)
  }
}
